<script setup>
import {
  UserIcon,
  ChartPieIcon,
  RectangleGroupIcon,
} from "@heroicons/vue/24/solid";
import { defineProps, defineEmits } from "vue";

defineProps({
  open: {
    type: Boolean,
    default: false,
  },
});

const handleLinkClick = () => {
  // Close sidebar only on mobile (< md breakpoint: 768px)
  if (window.innerWidth < 768) {
    emit("close-sidebar");
  }
};

const emit = defineEmits(["close-sidebar"]);
</script>

<template>
  <div
    class="flex flex-col py-4 px-5 rounded-2xl bg-primary-dark transition-all duration-300 ease-out overflow-hidden h-full"
    :class="open ? 'w-64 sm:w-64 opacity-100' : 'w-0 opacity-0 px-0'"
  >
    <div v-if="open" class="min-w-52 flex flex-col">
      <!-- Header with Logo and Close Button -->
      <div class="flex justify-between items-center mb-4">
        <img
          src="../../assets/chat-polls-logo.png"
          alt="Chat-Polls"
          class="object-contain h-8"
        />
        <button
          @click="$emit('close-sidebar')"
          class="md:hidden p-2 rounded-lg text-gray-400 hover:text-white hover:bg-white/10 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-primary"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Dashboard Button -->
      <div class="mt-6">
        <router-link
          to="/dashboard"
          @click="handleLinkClick"
          class="flex items-center gap-3 px-4 py-3 rounded-lg text-white hover:bg-white/10 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-primary"
          active-class="bg-btn-gradient font-semibold"
        >
          <div class="grid grid-cols-2 gap-0.5">
            <div class="w-2 h-2 bg-white rounded-sm"></div>
            <div class="w-2 h-2 bg-white rounded-sm"></div>
            <div class="w-2 h-2 bg-white rounded-sm"></div>
            <div class="w-2 h-2 bg-white rounded-sm"></div>
          </div>
          Dashboard
        </router-link>
      </div>

      <!-- Divider Line -->
      <div class="flex justify-center my-4">
        <hr class="border-gray-600 w-4/5" />
      </div>

      <!-- Pages Section -->
      <div class="my-4">
        <p
          class="text-gray-400 text-xs font-medium uppercase tracking-wider mb-3 text-center"
        >
          PAGES
        </p>
        <div class="flex flex-col gap-2">
          <router-link
            to="/polls"
            @click="handleLinkClick"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-white hover:bg-white/10 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-primary"
            :class="{
              'bg-btn-gradient font-semibold': $route.path.startsWith('/polls'),
            }"
          >
            <ChartPieIcon class="w-6 h-6" />
            Polls
          </router-link>

          <router-link
            to="/spaces"
            @click="handleLinkClick"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-white hover:bg-white/10 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-primary"
            active-class="bg-btn-gradient font-semibold"
          >
            <RectangleGroupIcon class="w-6 h-6" />
            Spaces
          </router-link>

          <router-link
            to="/members"
            @click="handleLinkClick"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-white hover:bg-white/10 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-primary"
            active-class="bg-btn-gradient font-semibold"
          >
            <UserIcon class="w-6 h-6" />
            User Management
          </router-link>

          <!-- <a
            href="#"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-white hover:bg-white/10 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-primary"
          >
            <ChartBarSquareIcon class="w-6 h-6" />
            Charts
          </a> -->
        </div>
      </div>

      <!-- Interface Section -->
      <!-- <div>
        <p
          class="text-gray-400 text-xs font-medium uppercase tracking-wider my-3 text-center"
        >
          INTERFACE
        </p>
        <div class="flex flex-col gap-2">
          <a
            href="#"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-white hover:bg-white/10 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-primary"
          >
            <Cog6ToothIcon class="w-6 h-6" />
            Components
          </a>

          <a
            href="#"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-white hover:bg-white/10 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-primary"
          >
            <AdjustmentsHorizontalIcon class="w-6 h-6" />
            Utilities
          </a>
        </div>
      </div> -->
    </div>
  </div>
</template>
